import React from 'react';

const Massachusetts = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Massachusetts Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Disclosure of known defects required; no specific form mandated.
        </li>
        <li>
          Mandatory Disclosures: Lead paint, septic system (Title V), and others
          as required.
          <li>Purchase and Sale Agreement: Often reviewed by attorneys.</li>
          <li>
            <span
              className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
              onClick={() => {
                window.open(
                  'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                  '_blank'
                );
              }}
            >
              Lead-Based Paint Disclosure{' '}
            </span>{' '}
            – Only for residences that were built before 1978. This information
            should be available at the County’s Revenue Office.
          </li>
          <li>
            <span
              className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
              onClick={() => {
                window.open(
                  'https://eforms.com/images/2018/07/Massachusetts-Association-of-Realtors-Property-Disclosure.pdf',
                  '_blank'
                );
              }}
            >
              Lead-Based Paint Disclosure{' '}
            </span>{' '}
            – While not required by Massachusetts state law, sellers may choose
            to provide buyers with a property condition report.
          </li>
          <li>
            <span
              className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
              onClick={() => {
                window.open(
                  'https://eforms.com/images/2018/07/Massachusetts-Title-5-Addendum-Septic-Tank-and-Cesspools.pdf',
                  '_blank'
                );
              }}
            >
              Title 5 Addendum (Septic Tanks){' '}
            </span>{' '}
            – Sellers must disclose the presence of septic tanks to buyers.
          </li>
        </li>
      </ol>
    </div>
  );
};

export default Massachusetts;
